// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mCFTm","image":"styles_image__19xYi","mt135":"styles_mt135__96X4c","cardWrapper":"styles_cardWrapper__3g8mO"};